export const ACTIVE_TAB_CHANGED = 'settings/ACTIVE_TAB_CHANGED';
export const activeTabChanged = payload => ({
  type: ACTIVE_TAB_CHANGED,
  payload,
});



// WEBPACK FOOTER //
// ./app-settings/actions/active-tab-changed.js